import React from 'react';
import { KiteGrid, KiteGridCell, KiteLink } from '@kite/react-kite';
import {
  ItemInterface,
  LinkItemInterface,
  getYourPrivacyRightLink,
  getCaliforniaConsumerPrivacyRightLink,
  getCaliforniaDoNotSellOptOutLink,
  getServiceRateDisclosuresLink,
  getPoliciesLink,
  getCaliforniaLimitedUseOfSensitiveInfoLink,
  getOpenSourceLibrariesLink,
  getPortalBaseUrl,
} from 'app-constants';
import styles from 'components/footer/styles/Footer.module.scss';
import FooterColumnLink from 'components/footer/FooterColumnLink';
import { isSMBPortal } from 'utils/applicationHelper';
import { TrackingHook, useTracking } from 'react-tracking';

interface Props {
  showLogo: boolean;
  showCanaryFooter: boolean;
}

const Legal: React.FC<Props> = ({ showLogo, showCanaryFooter }) => {
  const { trackEvent }: TrackingHook = useTracking({ page: 'login', component: 'Legal' });

  let links: LinkItemInterface[] | ItemInterface[] = [
    {
      uiName: `\u00A9 ${new Date().getFullYear()} Charter Communications` as any,
    },
    getYourPrivacyRightLink(),
    getCaliforniaConsumerPrivacyRightLink(),
    getCaliforniaDoNotSellOptOutLink(),
  ];

  if (!isSMBPortal()) {
    links = links.concat([getServiceRateDisclosuresLink()]);
  }

  links = links.concat([getPoliciesLink(), getCaliforniaLimitedUseOfSensitiveInfoLink(), getOpenSourceLibrariesLink()]);

  const linksList = links.map((link, index) => (
    <span key={index} className={styles.linkElement}>
      {link.href || link.baseUrl ? <FooterColumnLink {...(link as LinkItemInterface)} /> : link.uiName}
      {index < links.length - 1 && <span className={styles.verticalSeparator} />}
    </span>
  ));

  const isLoggedInStyles = showCanaryFooter ? styles.loggedOut : '';

  return (
    // The role attribute is listed here because VoiceOver has an issue where the footer landmark role is not announced in the landmark rotor without it. Leave the @ts-ignore until solved
    // @ts-ignore
    <KiteGridCell role="contentinfo" col={12} className={styles.legal}>
      <KiteGrid className={styles.linksContainer}>
        <KiteGridCell col={12} md={12} className={styles.linksContainer}>
          <p className={`${styles.links} ${isLoggedInStyles}`}>
            {showLogo && (
              <KiteLink
                className="focus-outline-primary"
                id="footerLogo"
                href={getPortalBaseUrl()}
                type="inline"
                data-testid="CharterLogo"
                onClick={() =>
                  trackEvent({
                    event: 'loginFooterLink',
                    url: getPortalBaseUrl(),
                    linkObject: { uiName: 'icon-logo', stdName: 'footer-logo' },
                  })
                }
              >
                <img className={styles.logo} src="/assets/images/charter-logo-footer.svg" alt="Charter" />
              </KiteLink>
            )}
            {linksList}
          </p>
        </KiteGridCell>
      </KiteGrid>
    </KiteGridCell>
  );
};

export default Legal;
